export default __webpack_public_path__ + "static/media/remove-active.9e493919.svg";